// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-09-23T10:09:27+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  189666
//    Project:        510
//    Environment:    3832 - master
//    MD5:            3768e8c6c369e1d67319ee4696369466
//    Signature:      eyJpdiI6ImlsNWtPaWkwYUJQTDVWZWdOenFlMUE9PSIsInZhbHVlIjoiUlFta2dOQUJhSkZkUVpnTGVIZWFsM2NWc1JuQ3B2UWdzN2NnT01IdFE1dGRFQTRPaGZWYlwvVjlqT3hjVUlmS3FuQ3BQQ0pTd3d2clVCRFNGejhGVFNcL3RHbXREZkFQb09VWlZPejVrVXRRSlQwa2F6MU0xWXF3R3c0RGVOZVppSXozNHJHS2NTYUlSV3hxOENrMjZcLytJWm5lc0UyMTd2aXJQWGxNam9VMk5DS1ZHaVNcL0lORHdxYTRMNUJIQXV6dDdEN0tuNkVITVFmSVM4RU11bEZnaE4xNXRYK2FHa2xhWDhQOFNXS3R2RkU0dnJ2b0x3bDRaQ0NGNkNJYWhMU1hTb0lUb3hUUGQ2S1lOZmJEbjlzUkZwUnoxWG1yZVdyWWk0NzJ3ZFp6dVZxMlpmTzUxazZwMXNzWTgzN2NyRmlMVFEwNGNiOURjaG9XQ2NYM3p6Vis0K3NqcjJUeE5mbk1MZEtwU3JiMWVsWXFjeUxcLzRTTGQyb3VveksyNWFKNEZ1VHp1T3N4TVYwcTh5V3NjeE0rdHBZUjFpM2Fta25CbWpcLzRQZ3JuZEt2MD0iLCJtYWMiOiIzZGM0YmNhYTdjMzZhNWYxNDEzMTY2YWUzMTBjZTUxMjRkZWIzZTg4NTQ1MjE0ZGI0MzgzZGVlYWYwMWY0MGZkIn0=
if (!window.__mpSwatchMoreInit) {
  window.__mpSwatchMoreInit = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-swatch-toggle]');
    if (!btn) return;

    const targetId = btn.getAttribute('aria-controls');
    const target = targetId ? document.getElementById(targetId) : null;

    if (!target) return;

    const expanded = target.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  });
}
